<template>
  <div class="templates-main-menu">
    <div class="d-none d-lg-flex align-items-center">
      <router-link
        :to="{ name: 'home' }"
        class="brand mr-5"
        :class="{ 'border-bottom': $route.name.includes('home') }"
      >
        <div class="decoration-link">Início</div>
      </router-link>

      <router-link
        :to="{ name: 'repertory' }"
        class="brand mr-5"
        :class="{ 'border-bottom': $route.name.includes('reperto') }"
      >
        <div class="decoration-link">Repertório</div>
      </router-link>
    </div>

    <div class="flex-fill d-none d-lg-flex"></div>

    <router-link
      :to="{ name: 'account' }"
      class="btn d-lg-none"
      @click.native="$emit('click-menu')"
    >
      <template v-if="$user.user">
        <div class="d-flex flex-row align-items-center">
          <img
            v-if="$user.user.image_profile"
            :src="$user.user.image_profile"
            class="img-profile-sm mr-2"
          />
          <div v-else class="img-profile-sm mr-2">{{ $user.user.name[0] }}</div>
          <span>Olá, {{ $user.user.name }}</span>
        </div>
      </template>
    </router-link>

    <search class="hide-footer pl-1" id="search" />

    <notifications-dropdown
      id="notifications"
      @click.native="$emit('click-menu')"
      class="d-none d-lg-flex"
    />

    <div class="d-flex flex-column d-lg-none pl-3">
      <router-link
        :to="{ name: 'home' }"
        class="brand mr-5 d-flex align-items-center decoration-link my-2"
        :class="{ 'border-bottom': $route.name.includes('home') }"
      >
        <i class="icon-settings mr-2" />
        <div>Início</div>
      </router-link>

      <router-link
        :to="{ name: 'repertory' }"
        class="brand mr-5 my-2 d-flex align-items-center decoration-link my-2"
        :class="{ 'border-bottom': $route.name.includes('reperto') }"
      >
        <i class="icon-music-folder mr-2" />

        <div>Repertório</div>
      </router-link>

      <router-link
        :to="{ name: 'repertory' }"
        class="brand mr-5 my-2 d-flex align-items-center decoration-link my-2"
        :class="{ 'border-bottom': $route.name.includes('reperto') }"
      >
        <i class="icon-amplifier mr-2" />

        <div>Meus Setlists</div>
      </router-link>

      <a
        class="brand mr-5 my-2 d-flex align-items-center decoration-link my-2"
        @click="$emit('logout')"
      >
        <i class="icon-power mr-2" />

        <div>Sair</div>
      </a>
    </div>

    <router-link
      :to="{ name: 'account' }"
      class="btn d-none d-lg-block"
      @click.native="$emit('click-menu')"
    >
      <template v-if="$user.user">
        <div class="d-flex flex-row align-items-center">
          <img
            v-if="$user.user.image_profile"
            :src="$user.user.image_profile"
            class="img-profile-sm mr-2"
          />
          <div v-else class="img-profile-sm mr-2">{{ $user.user.name[0] }}</div>
          <span>Olá, {{ $user.user.name }}</span>
        </div>
      </template>
    </router-link>

    <b-dropdown right class="d-none d-lg-block">
      <div class="dropdown-body">
        <div class="dropdown-header py-3">
          <img src="../../assets/images/triangulo.png" class="triangle-img" />
          <template v-if="$user.user">
            <div class="d-flex flex-column align-items-center">
              <p class="name-text my-0">{{ $user.user.name }}</p>

              <p class="email-text my-0">{{ $user.user.email }}</p>
            </div>
          </template>
        </div>
        <b-dropdown-item class="dropdown-item mt-2">
          <div class="d-flex flex-row align-items-center">
            <i class="icon icon-settings" />

            <router-link
              :to="{ name: 'account' }"
              class="btn d-flex align-items-center"
              @click.native="$emit('click-menu')"
            >
              <span class="text-uppercase">Minha conta</span>
            </router-link>
          </div>
        </b-dropdown-item>
        <hr />
        <b-dropdown-item class="dropdown-item">
          <div class="d-flex align-items-center">
            <i class="icon icon-music-folder" />
            <router-link
              :to="{ name: 'my-repertories' }"
              class="btn d-flex align-items-center"
              @click.native="$emit('click-menu')"
            >
              <span class="text-uppercase">Meus Setlists</span>
            </router-link>
          </div>
        </b-dropdown-item>
        <hr />
        <b-dropdown-item class="dropdown-item">
          <div class="d-flex align-items-center">
            <i class="icon icon-power" />
            <a class="btn d-flex align-items-center" @click="$emit('logout')">
              <span class="text-uppercase">Sair</span>
            </a>
          </div>
        </b-dropdown-item>
      </div>
    </b-dropdown>
  </div>
</template>
<script>
import NotificationsDropdown from "@/components/notifications/NotificationsDropdown";
import Search from "./Search";

export default {
  components: { Search, NotificationsDropdown },
  methods: {
    clickDropdown() {
      this.$emit("click-menu");
      this.$refs.dropdown.hide(true);
    }
  }
};
</script>

<style lang="scss" scoped>
.templates-main-menu {
  // ::v-deep .btn {
  //   display: flex;
  //   align-items: center;
  // }

  // ::v-deep .dropdown-item {
  //   color: #8395a7 !important;
  //   font-size: 12px;
  //   font-weight: bold;
  //   padding-top: 6px;
  //   padding-bottom: 6px;
  // }

  .img-profile-sm {
    border: 1px solid #2db563;
    border-radius: 50%;
    object-fit: cover;
    font-size: 24px;
    color: #fff;
    height: 32px;
    width: 32px;
  }

  .brand {
    text-decoration: none;
  }

  .decoration-link {
    color: #ffffff;
    transition: 0.4s;
    font-size: 16px;
    text-decoration: none;

    &:hover {
      font-size: 18px;
    }
  }

  .border-bottom {
    border-bottom: 1px solid #2db563 !important;
    width: fit-content;
  }

  .dropdown-body {
    background: #000 !important;

    .dropdown-header {
      background-color: #111112;
    }

    .dropdown-item {
      background: transparent;
      :hover {
        background: transparent;
      }
    }
  }
  .icon {
    color: #fff;
  }
  .icon-responsive {
    color: #8b8b8b;
    transition: 0.4s;
    font-size: 16px;
    text-decoration: none;

    &:hover {
      color: #fff;
      font-size: 18px;
    }
  }

  ::v-deep .dropdown-menu {
    background-color: #020204 !important;
    left: -20%;
    padding: 0px;

    .dropdown-item {
      padding-left: 10px;
    }
    .name-text {
      font-family: "Kelson";
      font-weight: 700;
      font-size: 18px;
      color: #ffffff;
    }

    span {
      font-size: 18px;
    }

    hr {
      background-color: #2b2b29;
      width: 90%;
      margin: auto;
    }

    .triangle-img {
      position: absolute !important;
      top: -2%;
      right: 6%;
      width: 16px;
      height: 8px;
      color: #fff;
    }
  }

  ::v-deep .dropdown-toggle {
    background-color: transparent !important;
    border: none !important;
  }
}
</style>
